(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/kambi-offering/assets/javascripts/live-data.js') >= 0) return;  svs.modules.push('/components/oddset/kambi-offering/assets/javascripts/live-data.js');
"use strict";


const {
  subscribe
} = svs.components.oddset.kambiOffering.setupSockets2;
const SocketMessageType = svs.components.oddset.kambiOffering.common.constants.SocketMessageType;
const {
  getLiveDatas
} = svs.components.oddset.kambiOffering;
const logger = svs.core.log.getLogger('components:oddset:live-data');
const POLLING_INTERVAL = 1000 * 10;
const liveDatas = new Map();
const liveDataListeners = new Set();
const initialDataPromises = new Map();
let pollingInterval;
let isFetching = false;
const notifyListeners = (eventId, newLiveData) => {
  liveDataListeners.values().forEach(listener => {
    if (listener.eventId === eventId) {
      listener.onUpdate(newLiveData);
    }
  });
};

const updateLiveData = (eventId, newLiveData) => {
  const oldLiveData = liveDatas.get(eventId);
  if (JSON.stringify(oldLiveData) !== JSON.stringify(newLiveData)) {
    liveDatas.set(eventId, newLiveData);
    notifyListeners(eventId, newLiveData);
  }
};
const rejectInitialLiveDataPromise = events => {
  events.forEach(eventId => {
    if (initialDataPromises.has(eventId)) {
      const promise = initialDataPromises.get(eventId);
      promise.forEach(_ref => {
        let {
          reject
        } = _ref;
        reject();
      });
      initialDataPromises.delete(eventId);
    }
  });
};
const fetchLiveDatas = async () => {
  isFetching = true;
  const liveDataEventIds = Array.from(liveDataListeners.values()).map(listener => listener.eventId);
  try {
    const {
      liveData
    } = await getLiveDatas(liveDataEventIds);
    if (!liveData || liveData.length === 0) {
      logger.debug('No livedata received from kambi');
      rejectInitialLiveDataPromise(liveDataEventIds);
    } else {
      const eventsWithoutLiveData = liveDataEventIds.filter(eventId => !liveData.some(liveDataObj => liveDataObj.eventId === eventId));
      rejectInitialLiveDataPromise(eventsWithoutLiveData);
      liveData.forEach(liveDataObj => {
        if (initialDataPromises.has(liveDataObj.eventId)) {
          const promise = initialDataPromises.get(liveDataObj.eventId);
          promise.forEach(_ref2 => {
            let {
              resolve
            } = _ref2;
            resolve(liveDataObj);
          });
          initialDataPromises.delete(liveDataObj.eventId);
        }
        updateLiveData(liveDataObj.eventId, liveDataObj);
      });
    }
  } catch (error) {
    rejectInitialLiveDataPromise(liveDataEventIds);
    liveDataListeners.forEach(listener => {
      listener.onError(error);
    });
    logger.error('Error while fetching kambi livedata', error.message, error.type, error);
  }
  isFetching = false;
};
const stopPolling = () => {
  clearInterval(pollingInterval);
  pollingInterval = undefined;
};
const startPolling = () => {
  if (pollingInterval && isFetching) {
    return;
  }
  if (pollingInterval) {
    stopPolling();
  }
  fetchLiveDatas();
  pollingInterval = setInterval(async () => {
    await fetchLiveDatas();
  }, POLLING_INTERVAL);
};
const addLiveDataListener = newListener => {
  liveDataListeners.add(newListener);
  startPolling();
};
const deleteLiveDataListener = listener => {
  liveDataListeners.delete(listener);
  if (liveDataListeners.size === 0) {
    stopPolling();
  }
};


const onSocketUpdate = message => {
  const {
    payload,
    type
  } = message;

  if (!liveDatas.has(payload.eventId)) {
    return;
  }
  const liveData = structuredClone(liveDatas.get(payload.eventId));
  switch (type) {
    case SocketMessageType.MatchClockUpdated:
      {
        var _liveData$matchClock, _payload$matchClock;
        if (!liveData.matchClock || ((_liveData$matchClock = liveData.matchClock) === null || _liveData$matchClock === void 0 ? void 0 : _liveData$matchClock.version) < ((_payload$matchClock = payload.matchClock) === null || _payload$matchClock === void 0 ? void 0 : _payload$matchClock.version)) {
          liveData.matchClock = payload.matchClock;
          updateLiveData(payload.eventId, liveData);
        }
        break;
      }
    case SocketMessageType.EventScoreUpdated:
      {
        if (payload !== null && payload !== void 0 && payload.score) {
          liveData.score = payload.score;
          updateLiveData(payload.eventId, liveData);
        }
        break;
      }
    default:
      break;
  }
};
const createInitialLiveDataPromise = eventId => {
  if (liveDatas.has(eventId)) {
    return liveDatas.get(eventId);
  }
  if (!initialDataPromises.has(eventId)) {
    initialDataPromises.set(eventId, []);
  }
  const {
    promise,
    resolve,
    reject
  } = Promise.withResolvers();
  initialDataPromises.get(eventId).push({
    resolve,
    reject
  });
  return promise;
};

const liveDataSubscribe = function (eventId, onUpdate) {
  let onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  if (!eventId) {
    throw new Error('eventId is required to subscribe to socket messages');
  }
  if (!onUpdate) {
    throw new Error('onUpdate function is required to subscribe to live data updates');
  }
  const listener = {
    eventId,
    onUpdate,
    onError
  };
  addLiveDataListener(listener);
  const socketUnsubscribe = subscribe(eventId, onSocketUpdate, onError);
  return {
    unsubscribe: () => {
      deleteLiveDataListener(listener);
      socketUnsubscribe();
    },
    initialData: createInitialLiveDataPromise(eventId)
  };
};
setGlobal('svs.components.oddset.kambiOffering.liveData', {
  liveDataSubscribe
});

 })(window);